<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{ "module-assignment.pettyCash.authentication_details" | translate
              }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content style="text-align: center; padding: 40px;">
            <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-padding-bottom-20">
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldFtpUrl" class="mat-block">
                  <input
                    id="txtuserFtpUrl"
                    matInput
                    [placeholder]="'rj.ftp_url' | translate"
                    formControlName="userFtpUrl"
                    [required]="isRequired('userFtpUrl')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldFtpUserName" class="mat-block">
                  <input
                    id="txtuserFtpUserName"
                    matInput
                    [placeholder]="'rj.ftp_username' | translate"
                    formControlName="userFtpUserName"
                    [required]="isRequired('userFtpUserName')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldFtpPassword" class="mat-block">
                  <input
                    id="txtuserFtpPassword"
                    matInput
                    type="password"
                    [placeholder]="'rj.ftp_password' | translate"
                    formControlName="userFtpPassword"
                    [required]="isRequired('userFtpPassword')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldFtpFolderName" class="mat-block">
                  <input
                    id="txtuserFtpFolderName"
                    matInput
                    type="text"
                    [placeholder]="'rj.ftp_folder' | translate"
                    formControlName="userFtpFolderName"
                    [required]="isRequired('userFtpFolderName')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldFtpPort" class="mat-block">
                  <input
                    id="txtuserFtpPort"
                    matInput
                    type="text"
                    [placeholder]="'rj.ftp_port' | translate"
                    formControlName="userFtpPort"
                    [required]="isRequired('userFtpPort')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <div
                  fxLayout="row wrap"
                  class="u-margin-top-10 u-margin-bottom-10"
                  fxLayoutGap="20px grid"
                >
                  <mat-checkbox
                    id="matCheckboxsftp{{authControlKey}}"
                    formControlName="sftp"
                    placeholder="SFTP"
                    >SFTP
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </mat-card-content>
          <!-- <mat-error *ngIf="!parentForm.valid">
            {{ "rj.authentication_details_required" | translate }}
          </mat-error> -->
        </mat-card>
      </div>
    </div>
  </div>
</div>
